"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Banner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _models = require("../../models");
var _constants = require("../BannerProductListing/constants");
var _components = require("./components");
const Banner = exports.Banner = (0, _mui.styled)('a', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, size, backgroundColor } = param;
    return {
        height: 315,
        position: 'relative',
        borderRadius: theme.spacing(1),
        overflow: 'hidden',
        textDecoration: 'none',
        '&:hover, &:focus, &:active': {
            color: theme.palette.text.primary,
            ["& .".concat(_components.BannerTextLinkClassName)]: {
                textDecoration: 'underline',
                textUnderlineOffset: theme.spacing(1),
                textDecorationThickness: 2
            }
        },
        display: 'flex',
        flexDirection: 'column',
        backgroundColor,
        order: size === _models.EditorialPlpPromoBannerSize.Size2 ? 5 : 'inherit',
        gridColumn: size === _models.EditorialPlpPromoBannerSize.Size2 ? 'span 2' : 'inherit',
        maxWidth: '100%',
        [theme.breakpoints.up('sm')]: {
            height: 385,
            order: 'inherit',
            maxWidth: _constants.BANNER_SIZE_IN_PX[size]
        }
    };
});
